import { DeviceType } from "@obg/ngx.global";

import { MetadataDeviceType } from "./model";

export function getDeviceTypeFromMeta(device: DeviceType): MetadataDeviceType {
	switch (device) {
		case DeviceType.Mobile:
			return MetadataDeviceType.Mobile;
		case DeviceType.Tablet:
			return MetadataDeviceType.Tablet;
		default:
			return MetadataDeviceType.Desktop;
	}
}
